import {theme} from "../../../../utils";

export const styles = {
    cardTitleWrapper: {
        backgroundColor: "#e4e4e7",
        padding: "20px",
        display: "flex",
        alignItems: "center"
    },
    rowText: {
        ...theme.typography.poppinsBodySemiBold,
        fontSize: "16px",
        flex: 1
    },
    gradientBg: {
        background: 'linear-gradient(to right, #233E74, #7AB9E382)',
        paddingTop: "41px",
        paddingBottom: "71px",
        mt: "-4px"
    },
    cardItemMainTitle: {
        ...theme.typography.opticianBodyRegular,
        fontSize: "30px",
        color: "#fff"
    },
    footerImageOverlay: {
        position: 'absolute',
        top: '30px',
        left: '30px',
        zIndex: 2,
        textAlign: 'left'
    },
    footerImageOverlayLabel: {
        fontFamily: 'Montserrat',
        fontWeight: '600',
        fontStyle: 'semiBold',
        fontSize: '14px',
        lineHeight: '18%',
        letterSpacing: '.19px',
        color: '#FFFFFF',
        mb: '15px'
    },
    footerImageOverlayTitle: {
        fontFamily: 'Poppins',
        fontWeight: '700',
        fontSize: '26px',
        fontStyle: 'italic',
        lineHeight: '110%',
        letterSpacing: '0px',
        color: '#FFFFFF'
    }
}